/**
 * Configuration options for shop resource type schedule configurations.
 * Used with shop_resource_type_schedule_configurations property on the /v1/shops endpoint.
 */
enum ShopResourceTypeScheduleMode {
  CABIN_ONLY = 'CABIN_ONLY',
  FITTER_AND_CABIN = 'FITTER_AND_CABIN',
}

export { ShopResourceTypeScheduleMode }
